module.exports = __webpack_public_path__ + "f5c984177947619906b617251df79b04.pdf";